import {TicketTypeVo} from '../../common/shared/api/nicolas/vo/TicketTypeVo.enum';
import {TicketKind} from '../generated/types';

export function createTicketKind(ticketTypeVo: TicketTypeVo): TicketKind {
  if (ticketTypeVo.startsWith('TT')) {
    return TicketKind.Own;
  } else if (ticketTypeVo.startsWith('RT')) {
    return TicketKind.Rent;
  } else {
    return TicketKind.Unknown;
  }
}
